// Interrupteurs de fonctionnalités : permettent de couper une fonctionnalité livrée sans la
// retirer du code, le temps qu'une dépendance externe soit prête ou qu'une décision produit
// tombe. Un drapeau à `false` doit rendre la fonctionnalité TOTALEMENT inatteignable — aucun
// point d'entrée visible, aucun appel réseau.
//
// Pour retirer un drapeau : le passer à `true`, vérifier, puis supprimer le drapeau ET ses
// points d'accroche (`grep -rn "FEATURES" src/` les liste tous).
export const FEATURES = {
    // Mode incognito (Voissa Premium / Admin) — désactivé sur demande produit.
    //
    // Requiert côté API, avant toute réactivation : la capability `canUseIncognito`, la route
    // `PATCH /users/me/set-toggle-incognito`, `incognitoTotal` sur les vues de story et la part
    // `incognito` des statistiques. Ces éléments vivent sur `develop` et ne sont pas déployés.
    //
    // À `false` : le sélecteur du menu disparaît, l'indicateur de la barre de navigation aussi,
    // l'incognito n'est plus vendu dans les offres, et les décomptes (stats, vues de story)
    // repassent au partage membres / invités d'origine.
    INCOGNITO: true,
};

export default FEATURES;
